import React from "react";
import { FaCheck } from "react-icons/fa";

function ServiceReasonItem({ reason, isSelected }) {
  return (
    <div
      className={`flex items-center justify-between p-2 rounded-lg border ${
        isSelected
          ? "bg-indigo-50 border-indigo-200"
          : "bg-white border-gray-200 hover:bg-gray-50"
      } transition-colors cursor-pointer`}
    >
      <div className="flex-1">
        <span className="text-base font-medium text-gray-900">{reason}</span>
      </div>
      {isSelected && (
        <div className="text-indigo-600">
          <FaCheck className="w-5 h-5" />
        </div>
      )}
    </div>
  );
}

export default ServiceReasonItem;
